export default {
    GETCOUNTRIES: '@_get_countries',
    ADDCOUNTRY: '@_add_new_country',
    EDITCOUNTRY: '@_edit_contry',
    DELETECOUNTRY: '@_delete_country',
    SINGLECOUNTRY: '@_get_single_country_to_edit',
};
